import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './css/TarckSummary.css';
import {checkText} from '../../../../util/util';
import $ from 'jquery';
let isShowSum = false;
class TarckSummary extends Component {
    constructor(props) {
		super(props);

		this.state = {
           
		};
    }
    componentDidMount(){
       
    }
    componentWillUnmount(){
        $( ".trackSumClose").unbind( "click" );
        isShowSum = false;
    }

    componentDidUpdate(){
        $( ".trackSumClose").unbind( "click" );
        $(".trackSumClose").click(function() {
            $(".trackSum").toggle("slide");
            if ( isShowSum ) {
                $( ".trackSumClose" ).removeClass( "fas fa-times-circle" );
                $( ".trackSumClose" ).addClass( "fas fa-plus-circle" );  
            } else {
                $( ".trackSumClose" ).removeClass( "fas fa-plus-circle" );
                $( ".trackSumClose" ).addClass( "fas fa-times-circle" );
            }
            isShowSum =!isShowSum;
        });
    }
    


    render () {
        const {track,trackHistory} = this.props;
        console.log("track",track,trackHistory)
        if((!track || (!track ) ) && (!trackHistory || (!trackHistory && !trackHistory.status)) )
            return <div></div>;
        let average_speed = track?track.average_speed:trackHistory.average_speed;
        let total_speed_over = track?track.total_speed_over:trackHistory.total_speed_over;
        let total_distance = track?track.total_distance:trackHistory.total_distance;
        let total_running_minute = track?track.total_running_minute:trackHistory.total_running_minute;
        let total_stop_minute = track?track.total_stop_minute:trackHistory.total_stop_minute;
        let total_machine_off_minute = track?track.total_machine_off_minute:trackHistory.total_machine_off_minute;
        let device_no = track?track.device_no:trackHistory.device_no;
        return (
            <div >
            <i className="fas fa-plus-circle trackSumClose"></i>
            <div className="trackSum col-10 col-sm-10 col-md-8 row" style={{display:"none"}}>
                <div className="device-no">
                    {device_no}
                </div>
                <div className="col-2">
                    <i className="fas fa-tachometer-alt"></i><h5>{checkText(average_speed,"-")}</h5><h6>/kph.</h6>
                    <font>ความเร็วเฉลีย</font>
                </div>
                <div className="col-2">
                    <i class="far fa-dizzy"></i><h5>{checkText(total_speed_over,"-")}</h5><h6>ครั้ง</h6>
                    <font>ความเร็วเกิน</font>
                </div>
                <div className="col-2">
                    <i class="fas fa-road"></i><h5>{checkText(total_distance,"-")}</h5><h6>กม.</h6>
                    <font>ระยะทางรวม</font>
                </div>
                <div className="col-2">
                    <i className="fas fa-car-side text-success"></i><h5>{checkText(total_running_minute,"-")}</h5><h6>นาที</h6>
                    <font>ระยะเวลาวิ่ง</font>
                </div>
                <div className="col-2">
                    <i className="fas fa-car-side text-info"></i><h5>{checkText(total_stop_minute,"-")}</h5><h6>นาที</h6>
                    <font>ระยะเวลาจอด</font>
                </div>
                <div className="col-2">
                    <i className="fas fa-car-side text-secondary"></i><h5>{checkText(total_machine_off_minute,"-")}</h5><h6>นาที</h6>
                    <font>ระยะเวลาดับ</font>
                </div>
            </div>
            </div>
        )
    }
}
TarckSummary.defaultProps = {
  
}

TarckSummary.propTypes = {
    trackList: PropTypes.object,
}
export default TarckSummary



// WEBPACK FOOTER //
// ./src/app/view/components/Monitor/TarckSummary/TarckSummary.js